import { FaArrowRightLong } from "react-icons/fa6"
import { PropTypes } from 'prop-types';
import { Link } from "react-router-dom";


const RelatedCourses = ({courses}) => {
    // const courses = [
    //     "Bachelor of Electrical Engineering",
    //     "Master In Engineering",
    //     "Diploma In Engineering",
    //     "Bachelor in Mechanical Engineering",
    //     "Bachelor In Civil Engineering",

    // ]
    return (
        <div className="w-full md:w-5/6 lg:w-[23rem] max-h-[28rem] overflow-y-auto bg-white rounded-2xl border-2 border-stone-300 p-6 py-8 flex flex-col gap-7" >
            <div className="w-full h-24  border-b flex items-center justify-center">
                <h1 className=" text-center text-slate-900 text-lg font-semibold ">Related Course</h1>
            </div>
            <div className="flex flex-col gap-8 items-start">
                {
                    courses?.map((course, index) => (
                        <Link to={`${course?.link || ""}`} key={index} className="flex items-center gap-2">
                            <div className="w-6 h-6 shrink-0 rounded-full text-white flex items-center justify-center bg-[#9c0000]">
                                <FaArrowRightLong />
                            </div>
                            <span className="text-slate-900 text-sm  2xl:text-base font-bold">{course?.name}</span>
                        </Link>
                    ))
                }
            </div>
        </div>
    )
}
RelatedCourses.propTypes = {
    courses: PropTypes.array
}
export default RelatedCourses